import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['headerIndex', 'header', 'tableContainer'];

    connect() {
        // Add a click event listener to the header index element
        this.headerIndexTargets.forEach(headerIndex => {
            headerIndex.addEventListener('click', this.scrollToHeader.bind(this));
        })
    }

    scrollToHeader(event) {
        // Get the header element that was clicked
        const header = this.headerTargets.find(header => header.dataset.headerId === event.target.dataset.headerId);

        if (header) {
            // Get the position of the header element
            const headerPosition = header.offsetLeft;

            // Set the scrollLeft property of the container element to the position of the header element
            // adjust for the width of the first  column in table
            // find width of first column

            const firstColumn = this.tableContainerTarget.querySelector('tbody tr:first-child td:first-child');
            const firstColumnWidth = firstColumn.offsetWidth;
            const targetPosition = headerPosition - firstColumnWidth;
            const currentScrollPosition = this.tableContainerTarget.scrollLeft;
            const distanceToScroll = targetPosition - currentScrollPosition;
            const duration = 200;
            const startTime = performance.now();

            const scroll = (timestamp) => {
                const elapsed = timestamp - startTime;
                const progress = elapsed / duration;
                this.tableContainerTarget.scrollLeft = currentScrollPosition + (distanceToScroll * progress);
                if (elapsed < duration) {
                    window.requestAnimationFrame(scroll);
                }
            }
            requestAnimationFrame(scroll)
        }
    }
}
